<template>
  <el-container
      class="bestFollowupCase"
      v-loading="workTableLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <el-header>
      <!-- <Header></Header> -->
    </el-header>
    <el-main class="container-main">
      <div class="top">
        <span class="title">最佳随访案例</span>
        <div class="go_back" @click="$router.push({path:'/workTable'})">
          <i style="font-size: 24px;font-weight:bold;" class="el-icon-arrow-left"></i>
        </div>
      </div>
      <div class="search-month">
        <el-date-picker
          :clearable="false"
          v-model="searchMonth"
          @change="monthChange"
          value-format="yyyy-MM"
          type="month"
          size="small"
          class="my-date-picker"
          placeholder="选择月">
        </el-date-picker>
        <span style="margin-left: 20px;font-size: 14px;color: red;" v-if="needVoteMonth.length > 0">
          *当前需要投票的月份有：
          <span v-for="(item, index) in needVoteMonth" :key="index">{{ item }}&nbsp;&nbsp;</span>
        </span>
      </div>
      <div class="case-container">
        <div class="case-item" v-for="(item, index) in caseFromTask" :key="index">
          <div class="case-item-title">{{ item.taskName }}</div>
          <el-table :data="item.caseLists" border style="width: 100%; " class="custom-table" :header-cell-style="rowClass" :row-class-name="rowClassName">
            <el-table-column prop="admitNo" label="推荐案例" width="110">
              <template slot-scope="scope">
                <el-button type="text" @click="goCaseDetail(scope.row)" :disabled="!voteDeadline" >查看{{scope.$index+1}}号案例</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="isListen" label="是否已听" width="80">
              <template slot-scope="scope">
                <span style="color:#67c23a;" v-if="scope.row.isListen">已听</span>
                <span style="color:#f6716c;" v-else>未听</span>
              </template>
            </el-table-column>
            <el-table-column prop="pullReason" label="选送原因" ></el-table-column>
            <el-table-column prop="bestRecordList" label="推荐时间段" width="160">
              <template slot-scope="scope">
                <p v-for="period in scope.row.bestRecordList" :key="period.id">
                  {{period.recordName}}<span style="padding: 0 5px;"></span>{{period.timePeriod}}；</p>
              </template>
            </el-table-column>
            <el-table-column prop="isChecked" label="投票" width="50">
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.isChecked"
                  @click="scopeChangeHandler($event, scope.row)"
                ></el-checkbox>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 6px;">
            <el-button type="primary" size="small" :disabled="cannotVote" @click="voteHandler(item)">提交投票</el-button>
            <span style="margin-left: 15px;font-size:15px;">截止时间： <span v-if="voteDeadline">{{voteDeadline}}</span><span style="color: red;" v-else>投票未开始</span></span>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer>
      <Footer></Footer>
    </el-footer>
  </el-container>
</template>
<script type="text/ecmascript-6">
import {mapGetters, mapMutations} from "vuex";
import Footer from '../common/Footer';

export default {
  name: "bestFollowupCase",
  data() {
    return {
      workTableLoading: false,
      searchMonth: new Date(),
      caseFromTask: [],
      voteDeadline: "",
      cannotVote: false,
      needVoteMonth: []

    }
  },
  computed: {
    ...mapGetters([
      "username",
      "userid",
    ]),
  },
  components: { Footer },
  mounted() {
    let vm = this
    vm.onload()
  },
  methods: {
    ...mapMutations(["setTaskCenterId","setTaskTitle","setQuestion"]),
    onload(){
      var date = new Date();
      this.searchMonth = date.getFullYear() + '-' + ((date.getMonth() + 1) < 9 ? `0${date.getMonth() + 1}` : (date.getMonth() + 1))

      
      this.queryPullMonth()
      this.getVoteDeadline()
      this.getBestCaseList()
    },
    queryPullMonth(){
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestBestFollowupCaseCallcenterControllerQueryPullMonth',
          params: {}
        }
      ).then(res => {
        if (res.status == 0) {
          this.needVoteMonth = JSON.parse(JSON.stringify(res.retValue))
        }
      })
    },
    monthChange(){
      this.getVoteDeadline()
      this.getBestCaseList()
    },
    getVoteDeadline(){
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestBestFollowupCaseCallcenterControllerQueryEndTimeInfoByPullMonth',
          params: {pullMonth: this.searchMonth}
        }
      ).then(res => {
        if (res.status == 0) {
          this.voteDeadline = res.retValue.endTime

          // 获取当前时间是否已到截止时间，如果到截止时间则投票按钮不可点击
          if (res.retValue.endTime) {
            let currentTime = new Date();
            let deadline = new Date(res.retValue.endTime);
            this.cannotVote = currentTime > deadline
          }else {
            this.cannotVote = true
          }
          
        }
      })
    },
    getBestCaseList() {
      this.workTableLoading = true
      this.caseFromTask  = []
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestBestFollowupCaseCallcenterControllerQueryBestFollowupCaseList',
          params: {
            seatId: this.userid,
            pullMonth: this.searchMonth
          }
        }
      ).then(res => {
        if (res.status == 0) {
          this.caseFromTask = res.retValue.reduce((acc, obj) => {
            let existingTask = acc.find(item => item.taskId === obj.taskId);
            if (existingTask) {
              existingTask.caseLists.push(obj);
            } else {
              let temp = {
                taskId: obj.taskId,
                taskName: obj.taskName,
                caseLists: [obj]
              }
              acc.push(temp);
            }
            return acc;
          }, []);
          this.workTableLoading = false
        }else {
          this.caseFromTask = []
          this.workTableLoading = false
        }
      })
    },
    scopeChangeHandler(change, scope) {
      scope.isChecked = !scope.isChecked
    },
    voteHandler(row) {
      let currentTask = this.caseFromTask.find(item => item.taskId === row.taskId )
      let _caseIds=[]
      currentTask.caseLists.forEach(item => {
        if (item.isChecked) {
          _caseIds.push(item.id)
        }
      })
      if(_caseIds.length >2){
        this.$message.warning("每人每个任务最多投两票")
        return 
      }
      console.log("_caseIds ", _caseIds );
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestBestFollowupCaseCallcenterControllerVote',
          params: {
            caseIds: _caseIds,
            taskId: currentTask.taskId,
            userId: this.userid
          }
        }
      ).then(res => {
        if (res.status == 0) {
          this.$message.success("投票成功")
        }
      })
    },
    goCaseDetail(row) {
      this.setTaskCenterId(row.taskId);
      this.setTaskTitle(row.taskName);
      localStorage.setItem('taskId',row.taskId)
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestNewFollowupQuestionListServiceGetFollowupTaskQuestionnaireNewId',
          params: {
            followupTaskId: row.taskId,
          }
        }
      ).then(res => {
        if (res.status == 0) {
          this.setQuestion(res.retValue);
          this.$router.push({
            path: '/caseStudyPage',
            query: {
              taskId: row.taskId,
              seatId: row.seatId,
              caseId: row.id,
              fpId: row.followupPatientId,
              followUpPatientInfoId: row.followupPatientInfoId, //followUpPatientInfoId大小写不可更改，问卷里会用到地址栏的这个值
              followUpWay:row.followUpWay,
            }
          })
        }else {
          this.$message.error(res.desc)
        }
      })
      
    },
    /**
     * 设置header的显示样式
     */
    rowClass() {
      return "background: rgb(232, 232, 232);color: #000;";
    },
    rowClassName({ row }) {
      if (row.isBest) {
        return 'custom-row-class'; // 自定义的 CSS 类名，用于设置背景颜色
      }
      return '';
    },
  },
}
</script>
<style lang="scss">
.bestFollowupCase {

  .container-main .case-container {
    .el-table .el-table__cell {
      padding: 6px 0;
    }
    .custom-row-class {
      background-color: rgb(225, 243, 216); /* 设置背景颜色为黄色 */
    }
    .el-table--border,
    .el-table td.el-table__cell, 
    .el-table th.el-table__cell.is-leaf{
      border-color: rgb(206, 206, 206);
    }
    
    .el-table--border::after, 
    .el-table--group::after, .el-table::before {
      background-color: rgb(206, 206, 206);
    }

  }
}
</style>
<style lang="scss" scoped>
.bestFollowupCase {
  .top {
    position: relative;
    height: 50px;
    line-height: 50px;
    text-align: center;
    .go_back {
      height: 50px;
      width: 40px;
      line-height: 50px;
      position: absolute;
      left:0;
      top: 0;
    }
    .go_back:hover {
      background: rgb(226, 226, 226);
      cursor: pointer;
    }
    .title {
      font-size: 26px;
      font-weight: 400;
    }
  }
  .container-main {
    min-height: calc(100vh - 60px - 60px);
      // border: 1px solid;
    // min-height: calc(100vh - 60px);
    overflow: auto;
    margin: 0px;
    color: #000;
    position: relative;
    .search-month {
      padding: 10px 20px;
      background-color: rgb(239, 239, 239);

    }
    .case-container {
      width: 100%;
      // padding: 0 20px 10px 20px;
      padding: 10px;
      background-color: rgb(239, 239, 239);
      max-height: calc(100vh - 225px);
      // border: 1px solid;
      overflow-y: auto;
      overflow-x: hidden;
      // overflow: overlay;
      // display: flex;
      // flex-wrap: wrap;
      // justify-content: space-between;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      // grid-gap: 20px;
      grid-auto-rows: minmax(100px, auto);/* 设置行的高度为自适应 */
      
      .case-item {
        // width: 32.5%;
        // margin-top: 5px;
        margin: 0 10px;
        margin-bottom: 15px;
        padding: 15px;
        background-color: #fff;
        box-shadow: 5px 5px 6px 3px #ccc;
        // border: 1px solid;
        display: flex;
        flex-direction: column;
        .case-item-title {
          margin-bottom: 10px;
          margin-top: 5px;
        }
      }
    }
  }
}
</style>